var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0957 6L5.0957 5.71176C5.0957 5.05061 5.0957 4.72004 5.1347 4.4428C5.38323 2.67607 6.77177 1.28753 8.5385 1.039C8.81574 1 9.14631 1 9.80746 0.999999V0.999999C10.4686 0.999999 10.7992 0.999999 11.0764 1.039C12.8432 1.28753 14.2317 2.67607 14.4802 4.4428C14.5192 4.72003 14.5192 5.05061 14.5192 5.71176L14.5192 6",
    stroke: "#005068",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4707 10.9995V8.99951",
    stroke: "#005068",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14453 10.9995V8.99951",
    stroke: "#005068",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.6C3 7.90294 3 7.05442 3.52721 6.52721C4.05442 6 4.90294 6 6.6 6L13.0118 6C14.7088 6 15.5573 6 16.0846 6.52721C16.6118 7.05442 16.6118 7.90294 16.6118 9.6V12C16.6118 14.8284 16.6118 16.2426 15.7331 17.1213C14.8544 18 13.4402 18 10.6118 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12L3 9.6Z",
    stroke: "#005068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.e8dcdea5e2d27287a18ccb89408f2006.svg";
export { ForwardRef as ReactComponent };